import React from 'react'

import { SvgProps } from './types'

function PlayCircleFillSvg({
  width,
  height,
  className,
  size,
  styles,
  fill,
}: SvgProps) {
  const { innerWidth } = window
  const defaultWidth = innerWidth > 1024 ? 's' : 'm'
  const sizeKey = typeof size === 'undefined' ? defaultWidth : size

  const scale = {
    xl: 3.0,
    lg: 2.5,
    m: 1.6,
    s: 0.8,
    xs: 0.5,
  }

  return (
    <svg
      style={{
        ...styles,
        ...{ transform: `scale(${scale[sizeKey]})` },
      }}
      width={width || '40'}
      height={height || '40'}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 40 40"
      stroke="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM16.0382 11.8918C15.1383 11.3586 14 12.0072 14 13.0532V26.9472C14 27.9933 15.1383 28.6419 16.0382 28.1086L27.7613 21.1616C28.6437 20.6388 28.6437 19.3617 27.7613 18.8388L16.0382 11.8918Z"
        fill={fill}
      />
    </svg>
  )
}

export default PlayCircleFillSvg
